<script lang="ts">
  import { orgTag } from "@nrk/origo";
  import { searchFilter, updateSearchFilter } from "state/page";
  import {productFruitsInstance} from "../../services/productFruitsService";

  function addTagToFilter(event: Event) {
    const target = event.currentTarget as HTMLInputElement;
    const data = target.value;
    const tag = data.trim();
    // Don't add empty tags or duplicates
    if (!tag || ($searchFilter.tags && $searchFilter.tags.includes(tag))) {
      return;
    }

    const tags = $searchFilter.tags ? [...$searchFilter.tags, tag] : [tag];
    updateSearchFilter("tags", tags);
    target.value = "";
  }

  function handleKeydown(event: KeyboardEvent & { currentTarget: EventTarget & HTMLInputElement }) {
    if (event.key === "Enter") {
      addTagToFilter(event as any);
      $productFruitsInstance?.api.events.track("tags-filter-added");
    }
  }
  // Remove the class from the orgTag SVG to prevent styling conflicts
  const orgTagIcon = orgTag.replace(/\sclass="org-tag"/g, "");
  let tagFieldFocus = false;
</script>

<button type="button">Tagger</button>
<bb-expand hidden={!$searchFilter.tags?.length}>
  <div class="container" class:focus={tagFieldFocus}>
    <label>
      <span class="tag-icon">{@html orgTagIcon}</span>
      <!-- svelte-ignore a11y-autofocus -->
      <input
        type="text"
        on:focus={() => (tagFieldFocus = true)}
        on:blur={() => (tagFieldFocus = false)}
        name="tag-filter"
        id="tag-filter"
        placeholder="Filtrer på tagger"
        on:change={addTagToFilter}
        on:keydown={handleKeydown}
      />
    </label>
  </div>
</bb-expand>

<style>
  .tag-icon {
    margin-left: var(--org-small);
    margin-right: var(--org-small);
    font-size: var(--org-small);
  }
  .container {
    display: flex;
    align-items: center;
    gap: 10px;
    background: var(--color-surface-primary);
    border-style: solid;
    border-width: 1px;
    border-color: var(--org-color-shade-2);
  }
  .container > label {
    display: flex;
    align-items: center;
    flex: 1;
  }
  .container.focus {
    box-shadow: var(--org-shadow-focus);
  }
  .container input {
    background: transparent;
    color: var(--org-color-gray-400);
    font-family: "Roboto";
    font-size: 14px;

    letter-spacing: -0.2px;
    outline: none;
    border: 0;

    flex: 1;
    width: 100%;
    padding: 10px 0;
  }

</style>
